import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import qs from 'qs'
import $storage from '../../public/js/storage.js'
import $publicUrl from '../../public/path/publicUrl.js'


Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: true,
        userName: 'root',
        passWord: '12345',
        shop: [],
        shopcarNum: 0,
        alertbox: false
    },
    mutations: {
        SET_TOKEN(state, token) {
            sessionStorage.setItem('token', token)
            state.token = token
        },
        REMOVE_TOKEN(state) {
            sessionStorage.removeItem('token')
        },
        add_shopnum(state, id) {
            let that = this;
            let json_ = {};
            if ($storage.get('user_data') != null) {

                json_['user_id'] = $storage.get('user_data').user_id;
                axios({
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                    },
                    url: $publicUrl.http1 + $publicUrl.personalmessage,
                    data: qs.stringify(json_),

                })
                    .then(function (response) {
                        console.log(response.data);
                        let data = response.data;
                        if (data.stateCode == 10000) {
                            state.shopcarNum = data.countGoods

                        } else {
                            state.shopcarNum = 0
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            } else {
                state.shopcarNum = 0
            }


        },
        Hide_alertbox(state) {
            state.alertbox = false
        },
        Show_alertbox(state) {
            state.alertbox = true
        }
    },
    actions: {},
    modules: {}
})